import { WidgetModel } from './widget.model';
export class AdvancedTextWidgetModel extends WidgetModel {}
